import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { isRelatedFederalContent } from '@/jurisdiction-mappings/jurisdiction-maps'
import { researchFiltersActions, aggregateStateSources, aggregateRelatedFederalContent } from './slice'

export const researchFiltersListenerMiddleware = createListenerMiddleware()
const startListener = researchFiltersListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

/**
 * When a state is toggled, compute source aggregation and related federal
 * recomputation as side effects, then apply them in a single dispatch.
 */
startListener({
  actionCreator: researchFiltersActions.toggleStateSelected,
  effect: (action, listenerApi) => {
    const { conversationId } = action.payload
    const originalFilters = listenerApi.getOriginalState().researchFiltersState.filters[conversationId]
    const newFilters = listenerApi.getState().researchFiltersState.filters[conversationId]
    if (!newFilters) return

    const { lrr: stateLrr, caselaw: stateCaselaw } = aggregateStateSources(newFilters.selectedStateNames)

    let federalLrr = newFilters.federalLrrSources
    let federalCaselaw = newFilters.federalCaselawSources

    if (originalFilters) {
      const oldRelatedLrr = originalFilters.federalLrrSources.filter((code) =>
        originalFilters.selectedStateNames.some((name) => isRelatedFederalContent(code, name).isRelatedLrr)
      )
      const oldRelatedCaselaw = originalFilters.federalCaselawSources.filter((code) =>
        originalFilters.selectedStateNames.some((name) => isRelatedFederalContent(code, name).isRelatedCaselaw)
      )

      if (oldRelatedLrr.length > 0 || oldRelatedCaselaw.length > 0) {
        federalLrr = federalLrr.filter((s) => !oldRelatedLrr.includes(s))
        federalCaselaw = federalCaselaw.filter((s) => !oldRelatedCaselaw.includes(s))

        if (newFilters.selectedStateNames.length > 0) {
          const related = aggregateRelatedFederalContent(newFilters.selectedStateNames)
          federalLrr = Array.from(new Set([...federalLrr, ...related.lrrSources]))
          federalCaselaw = Array.from(new Set([...federalCaselaw, ...related.courts]))
        }
      }
    }

    listenerApi.dispatch(
      researchFiltersActions.applyStateToggleSideEffects({
        conversationId,
        stateLrrSources: stateLrr,
        stateCaselawSources: stateCaselaw,
        federalLrrSources: federalLrr,
        federalCaselawSources: federalCaselaw,
      })
    )
  },
})
